import React from "react";
import { components } from "react-select";
export const PlaceSearchControl = (props: any) => <components.Control {...props}>{props.children}</components.Control>;
